import {CssBaseline} from '@material-ui/core';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import {initializeFirebase} from './firebase';
import reportWebVitals from './reportWebVitals';
import './index.css';

initializeFirebase();

ReactDOM.render(
  <React.StrictMode>
    <>
      <CssBaseline />
      <App />
    </>
  </React.StrictMode>,
  document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
